export default {
  initialized: false,
  pendingRequestsCount: 0,
  placeVisits: [],
  places: {},
};
